import { toast } from "react-toastify";
import { clearloginData } from "../../src/redux/slice/loginSlice";
import { clearcompaniesData } from "../../src/redux/slice/companySlice";
import { clearworkshopsData } from "../../src/redux/slice/workshopSlice";
import { clearParticipantDetailsData } from "../../src/redux/slice/participantDetailsSlice";
import { clearParticipantData } from "../..//src/redux/slice/participantSlice";
import { clearRegisterData } from "../..//src/redux/slice/registerSlice";
import { clearWorkshopAdminData } from "../..//src/redux/slice/workshopAdminSlice";
import { clearworkshopDetailsData } from "../..//src/redux/slice/workshopDetailSlice";
import {clearParticipantDashboardData} from "../..//src/redux/slice/participantDashboardSlice"
import moment from "moment-timezone";
import { JAPANESE_REGEX, 
  ENGLISH_REGEX, 
  FULLWIDTH_REGX, 
  SPACE_REGEX, 
  SYMBOL_REGEX, 
  HALF_WIDTH_KATAKANA_REGEX, 
  ENGLISH_WITH_SPACE } from "./common.regex";


const REQUIRED_ERROR_MSG_2 = "このフィールドは必須です。";
const MAX_ENGLISH_NAME_LENGTH = 200;
const MAX_JAPANESE_NAME_LENGTH = 100;

const isEnglishName = (nameValue) =>
  ENGLISH_WITH_SPACE.test(nameValue) ||
  (ENGLISH_REGEX.test(nameValue) && !JAPANESE_REGEX.test(nameValue));

const from_Invalid_status_array = "details";
export const showError = (response, t) => {
  if (response?.errors || response?.error) {
    if (response?.error?.error_code) {
      toast.error(t(response?.error?.error_code), { toastId: 1 });
    } else if (
      response?.errors?.error?.hasOwnProperty(from_Invalid_status_array)
    ) {
    }
  }
};

export const clearReducers=(dispatch)=>{
  dispatch(clearloginData())
  dispatch(clearcompaniesData())
  dispatch(clearworkshopsData())
  dispatch(clearParticipantDetailsData())
  dispatch(clearParticipantData())
  dispatch(clearRegisterData())
  dispatch(clearWorkshopAdminData())
  dispatch(clearworkshopDetailsData())
  dispatch(clearParticipantDashboardData())
}
export function extractDate(inputString) {
  const datePart = inputString?.split(" ")[0] || 0;
  return datePart;
}

export function extractDateAndTime(inputString) {
  const dateTimePart =
    (inputString?.split(" ")[0] || 0) +
    " " +
    (inputString?.split(" ")[1] ? inputString?.split(" ")[1]?.slice(0, 5) : "");
  return dateTimePart;
}

export function convertUTCToJST(utcDatetimeStr) {
  if (utcDatetimeStr) {
    const utcDatetime = moment.utc(utcDatetimeStr, "YYYY-MM-DD HH:mm:ss Z");
    const jstDatetime = utcDatetime.clone().tz("Asia/Tokyo");
    const jstFormattedString = jstDatetime.format("YYYY-MM-DD HH:mm:ss");
    return jstFormattedString;
  }
}

export function convertJSTtoUTC(jstDateTimeString) {
  if (jstDateTimeString) {
    // Assuming jstDateTimeString is in the format 'YYYY-MM-DD HH:mm:ss'
    const jstDateTime = moment.tz(jstDateTimeString, "Asia/Tokyo");

    const utcDateTime = jstDateTime.clone().utc();
    // Format the result in UTC
    const utcFormattedString = utcDateTime.format("YYYY-MM-DD HH:mm:ss");
    return utcFormattedString;
  }
}

export function FormattedDate(dateString) {
  // Parse the input date string using moment
  const parsedDate = moment(dateString);

  // Format the date to 'YYYY-MM-DD'
  const formattedDate = parsedDate.format("YYYY-MM-DD");

  return formattedDate;
}

export function isDateGreater(dateString1) {
  const currentDate = moment.utc();
  const jstDateTime = moment.tz(dateString1, "Asia/Tokyo");
  const inputDate = jstDateTime.clone().utc();
  return inputDate.isAfter(currentDate);
}

export function optionValueSet(value, key, options) {
  return options?.find((data) => data?.[key] === value);
}

export const getNameKanjiValidationError = (value) => {
  const normalized =
    typeof value === "string" ? value.trimEnd() : value;

  if (!normalized || !String(normalized).trim()) {
    return REQUIRED_ERROR_MSG_2;
  }

  const nameValue = String(normalized);

  if (JAPANESE_REGEX.test(nameValue) && SPACE_REGEX.test(nameValue)) {
    return "スペースは入力できません。";
  }
  
  const passesFullWidthTest =
    ENGLISH_REGEX.test(nameValue) ||
    FULLWIDTH_REGX.test(nameValue) ||
    (SPACE_REGEX.test(nameValue) &&
      !(SYMBOL_REGEX.test(nameValue) || HALF_WIDTH_KATAKANA_REGEX.test(nameValue)));

  if (!passesFullWidthTest) {
    return "記号・半角カタカナは入力できません。";
  }

  const passesSpaceTest =
    (!SPACE_REGEX.test(nameValue) && FULLWIDTH_REGX.test(nameValue)) ||
    ENGLISH_WITH_SPACE.test(nameValue);

  if (!passesSpaceTest) {
    return "複数のスペースは入力できません。";
  }

  if (isEnglishName(nameValue)) {
    if (nameValue.length > MAX_ENGLISH_NAME_LENGTH) {
      return "氏名は全角100文字以内にしてください。";
    }
  } else if (nameValue.length > MAX_JAPANESE_NAME_LENGTH) {
    return "氏名は全角100文字以内にしてください。";
  }

  return null;
};
export const parseApiFieldErrors = (error, t) => {
  const fieldErrors = {};

  if (!error?.details?.length) {
    return fieldErrors;
  }

  error.details.forEach((detail) => {
    const fieldError = detail?.errors?.[0];
    const errorCode = fieldError?.error_code;

    if (!detail?.field) {
      return;
    }

    fieldErrors[detail.field] =
      errorCode != null ? t(String(errorCode)) : fieldError?.message;
  });

  return fieldErrors;
};